import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryTopAppsReportRequestParamsDto {
    startDate: string;
    endDate: string;
    timezone: string;
    granularity?: CubeTimeDimensionGranularity;
}